import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * Renders a card component representing a single item.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.newScCard - The card object containing card details.
 * @param {string} props.newScCard.id - The unique identifier of the card.
 * @param {string} props.newScCard.firstName - The first name associated with the card.
 * @param {string} props.newScCard.lastName - The last name associated with the card.
 * @param {number} props.newScCard.daysInOnboarding - Days since the card was created (frozen once retired/paused).
 * @param {boolean} props.newScCard.isActive - Indicates if the card is active.
 * @returns {JSX.Element} JSX element representing the card component.
 */
const Card = ({ newScCard }) => {
    const { daysInOnboarding } = newScCard;
    const flagged = daysInOnboarding >= 121 && newScCard.isActive;

    let cardClass = 'newsc-single-card';
    if (newScCard.isPaused) {
        cardClass = 'newsc-single-card-paused';
    } else if (flagged) {
        cardClass = 'newsc-single-card-flagged-days';
    }

    return (
        <Link className={cardClass} to={`/newsc/${newScCard.id}`}>
            <p>{`${newScCard.lastName}, ${newScCard.firstName}`}</p>
            {typeof daysInOnboarding === 'number' && (
                <span className="newsc-day-count-badge">
                    Day {daysInOnboarding}
                </span>
            )}
        </Link>
    );
};

Card.propTypes = {
    newScCard: PropTypes.object.isRequired
};

export default Card;
